import React from 'react';
import Spinner from 'react-spinkit';
import i18next from 'i18next';
import { connect } from 'react-redux';
import Api from '../../api';
import CryptoWalletsList from '../Crypto/CryptoWalletsList/CryptoWalletsList';
import Cancellable from '../Cancellable/Cancellable';
import CryptoCalc from '../Crypto/CryptoCalc/CryptoCalc';
import { setWallets } from '../../actions/userActions';
import HoverImage from "react-hover-image";
import binanceLogoCb from 'images/logo_trade/binance_cb.png';
import binanceLogo from 'images/logo_trade/binance.png';
import bitfinexLogoCb from 'images/logo_trade/bitfinex_cb.png';
import bitfinexLogo from 'images/logo_trade/bitfinex.png';
import coinbaseLogoCb from 'images/logo_trade/coinbase_cb.png';
import coinbaseLogo from 'images/logo_trade/coinbase.png';
import krakenLogoCb from 'images/logo_trade/kraken_cb.png';
import krakenLogo from 'images/logo_trade/kraken.png';
import trustLogoCb from 'images/logo_trade/trust_cb.png';
import trustLogo from 'images/logo_trade/trust.png';
import ledgerLogoCb from 'images/logo_trade/ledger_cb.png';
import ledgerLogo from 'images/logo_trade/ledger.png';
import ftxLogoCb from 'images/logo_trade/ftx_cb.png';
import ftxLogo from 'images/logo_trade/ftx.png';
import kucoinLogoCb from 'images/logo_trade/kucoin_cb.png';
import kucoinLogo from 'images/logo_trade/kucoin.png';
import metamaskLogoCb from 'images/logo_trade/metamask_cb.png';
import metamaskLogo from 'images/logo_trade/metamask.png';

class DepositFormCrypto extends Cancellable {
  constructor(props) {
    super(props);

    this.state = {
      coins: [],
      loaded: false,
      selectedCoin: null,
    };
  }

  componentDidMount() {
    this.fetchCoins();
  }

  fetchCoins = () => {
    return this.request(Api.coins()).then((response) => {
      this.setState({ coins: response.data || [], loaded: true });
    });
  };

  selectCoin = (coinId) => {
    this.setState({ selectedCoin: coinId });
  };

  fetchWallets = () => {
    this.request(Api.wallets()).then((response) => {
      this.props.setWallets(response.data || {});
    });
  };

  handleCoinSelectChange = ({ value }) => {
    this.selectCoin(value);
  };

  render() {
    return (
      <div className="form deposit-form-crypto">
        <span className="form__title form__title--center form__title--secondary">
          {i18next.t('deposit_crypto.title')}
        </span>

        {this.state.loaded ? (
          <React.Fragment>
            <CryptoWalletsList
              coins={this.state.coins}
              wallets={this.props.wallets}
              onWalletCreated={this.fetchWallets}
              onAddressClick={this.selectCoin}
            />
            <CryptoCalc
              coins={this.state.coins}
              coin={this.state.selectedCoin}
              onChange={this.handleCoinSelectChange}
            />
          </React.Fragment>
        ) : (
          <Spinner
            name="ball-clip-rotate"
            className="deposit-form-crypto__loader"
            color="white"
            fadeIn="quarter"
          />
        )}

        <span className="form__title trade_box_title form__title--center form__title--secondary">
          {i18next.t('deposit_crypto.trades')}
        </span>
        <div className="logo_trade_box">
          <a target="_blank" className="text-icon" href="https://www.ledger.com/ledger-live">
          <HoverImage className='img_logo_trade' src={ledgerLogoCb} hoverSrc={ledgerLogo} />
          </a>
          <a target="_blank" className="text-icon" href="https://trustwallet.com/">
          <HoverImage className='img_logo_trade' src={trustLogoCb} hoverSrc={trustLogo} />
          </a>
          <a target="_blank" className="text-icon" href="https://www.kucoin.com/express">
          <HoverImage className='img_logo_trade' src={kucoinLogoCb} hoverSrc={kucoinLogo} />
          </a>
          <a target="_blank" className="text-icon" href="https://www.coinbase.com/wallet">
          <HoverImage className='img_logo_trade' src={coinbaseLogoCb} hoverSrc={coinbaseLogo} />
          </a>
          <a target="_blank" className="text-icon" href="https://www.coinbase.com/wallet">
          <HoverImage className='img_logo_trade' src={bitfinexLogoCb} hoverSrc={bitfinexLogo} />
          </a>
          <a target="_blank" className="text-icon" href="https://www.binance.com/en/buy-sell-crypto?channel=card&fiat=USD">
          <HoverImage className='img_logo_trade' src={binanceLogoCb} hoverSrc={binanceLogo} />
          </a>
          <a target="_blank" className="text-icon" href="https://www.kraken.com/">
          <HoverImage className='img_logo_trade' src={krakenLogoCb} hoverSrc={krakenLogo} />
          </a>
          <a target="_blank" className="text-icon" href="https://ftx.com/">
          <HoverImage className='img_logo_trade' src={ftxLogoCb} hoverSrc={ftxLogo} />
          </a>
          <a target="_blank" className="text-icon" href="https://metamask.io/">
          <HoverImage className='img_logo_trade' src={metamaskLogoCb} hoverSrc={metamaskLogo} />
          </a>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      wallets: state.user.wallets,
    };
  },
  {
    setWallets,
  }
)(DepositFormCrypto);



// WEBPACK FOOTER //
// ./app/components/Form/DepositFormCrypto.jsx